<template>
  <div>
    <div class="cell" @click="showNotes = !showNotes">
      <span class="time">{{matchTimeStr()}}</span>
      <div class="leftTeam">
        <div class="space"></div>
        <div class="redCard" v-if="parseInt(match.homeRedCard) > 0"><span>{{match.homeRedCard}}</span></div>
        <div class="leftTeamName" @click="clickTeamName(match.homeTeamId)">{{match.homeTeam}}</div>
      </div>
      <div v-if="match.score.length > 2" @click="clickScore()" class="middleScore">
        <p class="score">{{homeTeamScore}}-{{awayTeamScore}}</p>
        <p class="halfScore">({{homeTeamHalfScore}}-{{awayTeamHalfScore}})</p>
      </div>
      <span v-else-if="match.score.length == 2" @click="clickScore()" class="middle">VS</span>
      <div class="rightTeam">
        <div class="rightTeamName" @click="clickTeamName(match.awayTeamId)">{{match.awayTeam}}</div>
        <div class="redCard" v-if="parseInt(match.awayRedCard) > 0"><span>{{match.awayRedCard}}</span></div>
      </div>
    </div>
    <!-- 备注 -->
    <div v-if="showNotes && match.remark.length > 0" class="notes">
      <div class="content">
        <div class="bottom">{{notesStr()}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateAndTimeConverter } from '@/utils'

export default {
  props: {
    match: {
      type: Object,
      default: () => Object
    }
  },
  created () {
    this.filterTeamScoreArray()
  },
  watch: {
    match (val) {
      this.resetData()
      this.filterTeamScoreArray()
    }
  },
  data () {
    return {
      showNotes: false,
      homeTeamScore: 0,
      homeTeamHalfScore: 0,
      awayTeamScore: 0,
      awayTeamHalfScore: 0
    }
  },
  methods: {
    clickTeamName: function (teamId) {
      this.$router.push({ name: 'football-team-schedule', params: { teamId: teamId.toString() } })
    },
    clickScore: function () {
      var tab = this.match.score.length > 2 ? 0 : 2
      if (this.match.score.length > 2) { // 完场
        tab = 0
      } else {
        tab = 2
      }

      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        // iOS
        let jsonprc = {
          jsonrpc: 2.0,
          method: 'openCustomScheme',
          params: `sevenmmobile://%7b%22__cls__%22%3a%22SMMatchDetailViewController%22%2c%22sportType%22%3a1%2c%22matchID%22%3a${this.match.gameId}%2c%22defaultTopIndex%22%3a${tab}%7d`
        }
        window.webkit.messageHandlers.nativeCallBack.postMessage(jsonprc)
      } else {
        // Android
        let params = {
          jumpUrl: `sevenmmobile://com.sevenm.view.singlegame.SingleGame?mId=${this.match.gameId}&kindNeed=0&tabFir=${tab}`
        }
        window.JsPhone.jumpPageUrl(JSON.stringify(params))
      }
    },
    // 重置数据
    resetData: function () {
      this.showNotes = false
      this.homeTeamScore = 0
      this.homeTeamHalfScore = 0
      this.awayTeamScore = 0
      this.awayTeamHalfScore = 0
    },
    // 截取比分
    filterTeamScoreArray: function () {
      if (this.match.score.length > 2) {
        let scoreAry = this.match.score.split('-')
        let awayScoreAry = scoreAry[1].split('(')

        this.homeTeamScore = scoreAry[0]
        this.awayTeamScore = awayScoreAry[0]
        this.homeTeamHalfScore = awayScoreAry[1]
        this.awayTeamHalfScore = scoreAry[2].split(')')[0]
      }
    },
    // 比赛时间
    matchTimeStr: function () {
      return dateAndTimeConverter(this.match.startTime)
    },
    // 备注内容
    notesStr: function () {
      var remark = this.match.remark.replace('<br>', ' ')
      remark = remark.replace('<br/>', ' ')
      return remark
    }
  }
}
</script>

<style lang="scss" scoped>
@import "style"
</style>
